import { $authHost } from "../../http";
import { 
    ACT_STATE_GET_REQUEST, ACT_STATE_GET_SUCCESS, ACT_STATE_GET_ERROR, 
    ACT_STATE_GET_BY_KEY_REQUEST, ACT_STATE_GET_BY_KEY_SUCCESS, ACT_STATE_GET_BY_KEY_ERROR, 
    ACT_STATE_ADD_REQUEST, ACT_STATE_ADD_SUCCESS, ACT_STATE_ADD_ERROR, 
    ACT_STATE_EDIT_REQUEST, ACT_STATE_EDIT_SUCCESS, ACT_STATE_EDIT_ERROR, 
    ACT_STATE_DELETE_REQUEST, ACT_STATE_DELETE_SUCCESS, ACT_STATE_DELETE_ERROR
} from "../constants/actStateConstants";

export const getActStates = (args) => async (dispatch) => {
    try {
        dispatch({
            type: ACT_STATE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/actState/query",
            args || {},
            config,
        );
        dispatch({
            type: ACT_STATE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: ACT_STATE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getActStateByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: ACT_STATE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/actState/${id}`,
        );
        dispatch({
            type: ACT_STATE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: ACT_STATE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addActState = ({ name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ACT_STATE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/actState",
            { name, code },
            config,
        );
        dispatch(getActStates(queryArgs || {}));
        dispatch({
            type: ACT_STATE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ACT_STATE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editActState = ({ id, name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ACT_STATE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/actState",
            { id, name, code },
            config,
        );
        dispatch(getActStates(queryArgs || {}));
        dispatch({
            type: ACT_STATE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ACT_STATE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteActState = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ACT_STATE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/actState",
            { data: { id } },
            config,
        );
        dispatch(getActStates(queryArgs || {}));
        dispatch({
            type: ACT_STATE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ACT_STATE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

